import { AlignmentToolBase } from './alignment-tool-base';
import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { ToolGroup } from '../tool-group';

export class AlignLeftTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/alignleft.svg');
    }

    public override getName(): string {
        return 'Align Left';
    }

    public override getTooltip(): string {
        return 'Align elements to left';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const leftMost = Math.min(...boxes.map(b => b.box.x));

        boxes.forEach(({element, box}) => {
            const deltaX = leftMost - box.x;
            if (deltaX !== 0) {
                element.move(deltaX, 0);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
}

export class AlignCenterHorizontalTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/aligncenter.svg');
    }

    public override getName(): string {
        return 'Align Center';
    }

    public override getTooltip(): string {
        return 'Align elements to horizontal center';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const centerX = boxes.reduce((sum, {box}) => sum + (box.x + box.width/2), 0) / boxes.length;

        boxes.forEach(({element, box}) => {
            const currentCenter = box.x + box.width/2;
            const deltaX = centerX - currentCenter;
            if (deltaX !== 0) {
                element.move(deltaX, 0);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
}

export class AlignRightTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/alignright.svg');
    }

    public override getName(): string {
        return 'Align Right';
    }

    public override getTooltip(): string {
        return 'Align elements to right';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const rightMost = Math.max(...boxes.map(b => b.box.x + b.box.width));

        boxes.forEach(({element, box}) => {
            const deltaX = rightMost - (box.x + box.width);
            if (deltaX !== 0) {
                element.move(deltaX, 0);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
} 
